import { createFileRoute, redirect } from "@tanstack/react-router"
import { ChangeProjectPublish } from "@/features/change-projects/components/ChangeProjectPublish"
import { canManageBulkUpdates } from "@/features/change-projects/core/access"

export const Route = createFileRoute("/(authenticated)/bulk-updates/$changeProjectId/publish")({
  beforeLoad: ({ context, params }) => {
    if (!canManageBulkUpdates(context.user)) {
      throw redirect({
        to: "/bulk-updates/$changeProjectId/review",
        params: { changeProjectId: params.changeProjectId },
        replace: true,
      })
    }
  },
  component: PublishStep,
})

function PublishStep() {
  const { changeProjectId } = Route.useParams()
  return <ChangeProjectPublish changeProjectId={changeProjectId} />
}
